import Vue from 'vue'
import Vuex from 'vuex'
import store from "./store"
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

const options = {
  key: "vuex",
  paths: ["store"],
  storage: window.sessionStorage
}

export default new Vuex.Store({
  modules: { store },
  strict: process.env.NODE_ENV !== 'production',
  plugins: [createPersistedState(options)]
})
